module.exports = __webpack_public_path__ + "static/img/5.5fa45d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/5.png
// module id = rXOy
// module chunks = 0